module.exports = __webpack_public_path__ + "../resources/img/ic_check_primary.b883aaba.svg";